<template>
  <div style="padding: 8px;">
    <!--渲染表单-->
    <el-form ref="form" class="process-form" label-position="top" :rules="rules" :model="_value">
      <template v-for="(item, index) in forms">
        <div class="item-form">
          <el-form-item :key="item.name + index" v-if="item.name !== 'SpanLayout' && item.name !== 'Description'" :prop="item.id" :label="item.title">
            <form-design-render :ref="`sub-item_${item.id}`" v-model="_value[item.id]" :isDisabled="false" mode="PC" :config="item"/>
          </el-form-item>
          <template v-else>
            <form-design-render :key="index" ref="span-layout"  v-model="_value" mode="PC" :config="item"/>
          </template>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import FormDesignRender from '@/views/admin/layout/form/FormDesignRender'

export default {
  name: "FormRender",
  components: {FormDesignRender},
  props:{
    formId: {
      type: String,
      default: () => {
        return null
      }
    },
    forms: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {},
    }
  },
  created() {
    setTimeout(() => {
    this.loadFormConfig(this.forms)
    }, 2000);
  },
  computed: {
    _value:{
      get(){
        return this.value
      },
      set(val){
        this.$emit('input', val)
      }
    }
  },
  methods: {
    validate(call) {
      let success = true
      this.$refs.form.validate(valid => {
        success = valid
        if(valid){
          //校验成功再校验内部
          for (let i = 0; i < this.forms.length; i++) {
            if (this.forms[i].name === 'TableList'){
              let formRef = this.$refs[`sub-item_${this.forms[i].id}`]
              if (formRef && Array.isArray(formRef) && formRef.length > 0){
                formRef[0].validate(subValid => {
                  success = subValid
                })
                if (!success){
                  break
                }
              }
            }
          }
        }
        call(success)
      });
    },
    loadFormConfig(forms){
      console.log("------------------")
      let echoData = JSON.parse(localStorage.getItem(this.formId));
      console.log(echoData)
      console.log(forms)
      forms.forEach(item => {
        if (item.name === 'SpanLayout'){
          this.loadFormConfig(item.props.items)
        }else {
          let value = echoData == null ? null : echoData[item.id];
          console.log(value)
          this.$set(this._value, item.id,value ? value:this.value[item.id])
          if(item.props.required){
            this.$set(this.rules, item.id, [{
              type: item.valueType === 'Array' ? 'array': undefined,
              required: true,
              message: `请填写${item.title}`, trigger: 'blur'
            }])
          }
        }
      })
      console.log("------------------")
    }
  }
}
</script>

<style lang="less" scoped>
.process-form {
  /deep/ .el-form-item__label {
    padding: 0 0;
  }
  /deep/ .el-form-item{
    padding: 0 0;
  }
  .el-form-item{
    padding: 0 0;
  }
}

.item-form{
  background-color: white;
  padding: 10px;
  margin: 8px 0;
  border-radius: 10px;
}
</style>
